export default __webpack_public_path__ + "static/media/done_deal_migration.6f98c533.svg";